// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCaretRightOutlinedSvg from "@fishx/icons-svg/es/asn/PCaretRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PCaretRightOutlined = function PCaretRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCaretRightOutlinedSvg
  }));
};

PCaretRightOutlined.displayName = 'PCaretRightOutlined';
export default React.forwardRef(PCaretRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCaretRightOutlined.js
// module id = 3267
// module chunks = 0